<template>
  <direct-chat-block
    icon="account_circle"
    :title="$t('INTEGRATION_SETTINGS.DIRECT_CHAT.WITH_CUSTOMERS.TITLE')"
    :description="$t('INTEGRATION_SETTINGS.DIRECT_CHAT.WITH_CUSTOMERS.DESC')"
  >
    <input-v2
      v-model.trim="clientName"
      :label="
        $t('INTEGRATION_SETTINGS.DIRECT_CHAT.WITH_CUSTOMERS.CLIENT_NAME.LABEL')
      "
      :placeholder="
        $t(
          'INTEGRATION_SETTINGS.DIRECT_CHAT.WITH_CUSTOMERS.CLIENT_NAME.PLACEHOLDER'
        )
      "
    />

    <phone-input-v2
      v-model="phone"
      :label="
        $t(
          'INTEGRATION_SETTINGS.DIRECT_CHAT.WITH_CUSTOMERS.CLIENT_PHONE_NUMBER.LABEL'
        )
      "
      :placeholder="
        $t(
          'INTEGRATION_SETTINGS.DIRECT_CHAT.WITH_CUSTOMERS.CLIENT_PHONE_NUMBER.PLACEHOLDER'
        )
      "
    />

    <button-v2
      class="self-start mt-2 !text-base"
      :disabled="!phoneDigits"
      @click="generate"
    >
      {{ $t('INTEGRATION_SETTINGS.DIRECT_CHAT.GENERATE_LINK') }}
    </button-v2>

    <template #result>
      <div>
        <div class="text-sm leading-5 font-semibold text-gray-700 mb-1.5">
          {{ $t('INTEGRATION_SETTINGS.DIRECT_CHAT.GENERATED_LINK') }}
        </div>
        <copy-field-v2
          :value="link"
          :placeholder="$t('INTEGRATION_SETTINGS.DIRECT_CHAT.LINK_PLACEHOLDER')"
          :copy-label="$t('INTEGRATION_SETTINGS.DIRECT_CHAT.COPY')"
        />
      </div>
    </template>
  </direct-chat-block>
</template>

<script>
import { mapGetters } from 'vuex';
import DirectChatBlock from './DirectChatBlock.vue';
import { toPhoneDigits } from './helpers';

export default {
  name: 'ChatWithCustomers',
  components: { DirectChatBlock },
  data() {
    return {
      phone: '',
      clientName: '',
      link: '',
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      getAccount: 'accounts/getAccount',
    }),
    account() {
      return this.getAccount(this.accountId);
    },
    iPracticomFeatures() {
      return this.account.platform_features?.iPracticom;
    },
    oneCityFeatures() {
      return this.account.platform_features?.one_city;
    },
    phoneDigits() {
      return toPhoneDigits(this.phone);
    },
    platformLink() {
      if (this.iPracticomFeatures) {
        return 'https://chat.ip-com.co.il';
      }
      if (this.oneCityFeatures) {
        return 'https://www.onecity.co.il';
      }
      return 'https://chat.99digital.co.il';
    },
  },
  methods: {
    generate() {
      if (!this.phoneDigits) {
        return;
      }
      this.link = `${this.platformLink}/${this.accountId}/${
        this.phoneDigits
      }/${encodeURIComponent(this.clientName)}`;
    },
  },
};
</script>
